(() => {
  const hasSeen = localStorage.getItem("app-banner-seen");

  if (hasSeen) {
    document.querySelector(".app-banner")?.classList.add("app-banner--closed");
    return;
  }

  const close = document.querySelector<HTMLButtonElement>(".app-banner__close");

  close?.addEventListener("click", () => {
    document.querySelector(".app-banner")?.classList.add("app-banner--closed");
    localStorage.setItem("app-banner-seen", "true");
  });

  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    const downloadButton = document.querySelector<HTMLAnchorElement>(
      ".app-banner__download"
    );

    if (!downloadButton) return;

    downloadButton.href = window.location.hostname.includes("pvda")
      ? "https://apps.apple.com/us/app/pvda/id6469100753"
      : "https://apps.apple.com/be/app/ptb/id6469188929?l=nl";
  }
})();
